import { v4 as uuidV4 } from 'uuid';
import { Creator } from '~/clientApi/creator.model';
import { ICreator } from '~/types';

export const getMediaKitPayload = (creator: Creator | ICreator) => {
  return {
    name: `${creator.fullName}'s Media Kit`,
    blocks: [
      {
        component: 'TalentProfile',
        id: uuidV4(),
        properties: {
          creator: {
            avatar: creator.avatar,
            fullName: creator.fullName,
            id: creator.id,
          },
          creatorId: creator.id,
        },
      },
    ],
  };
};
